module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA18.cc60926d.jpg";